{
  "pageTitle": "Invoices",
  "noInvoicesFound": "No invoices found",
  "noInvoicesHint": "Try adjusting filters or run scraping to import invoices.",
  "filterStatus": "Status",
  "filterProvider": "Provider",
  "filterAddress": "Address",
  "filterDate": "Date",
  "dateFrom": "From",
  "dateTo": "To",
  "show": "Show",
  "perPage": "per page",
  "tapToOpen": "Tap to open",
  "edit": "Edit",
  "delete": "Delete",
  "clearAll": "Clear all",
  "pagination": {
    "range": "Showing {{start}}–{{end}} of {{total}}"
  },
  "detail": {
    "date": "Date",
    "createdAt": "Created At",
    "address": "Address",
    "provider": "Provider",
    "amount": "Amount",
    "status": "Status",
    "datePaid": "Paid",
    "reference": "Reference",
    "taxDeduction": "Tax deduction",
    "skipPayment": "Payment"
  },
  "results": "Results",
  "deleteConfirmTitle": "Delete invoice?",
  "deleteConfirmMessage": "Invoice #{{id}} will be removed from the list."
}
